module.exports = "/assets/images/paypal_3decf5.svg";